import React, { useState, useEffect } from "react";
import { Paper, Typography, Button } from "@material-ui/core";
import { useStyles } from "./classes";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
import { useDispatch } from "react-redux";
import { hideHeader, showHeader } from "../../redux/actions/header";

const FavoriteMenuCard = ({ res, idx }) => {

  const classes = useStyles();
  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const user = JSON.parse(localStorage.getItem("profile"));
  let dispatch = useDispatch();

  useEffect(() => {
    if (!isOpen) {
      dispatch(showHeader());
    }
  }, [user,isOpen,dispatch]);

  const images = res.images;
  return (
    <Paper className={classes.list} key={idx}>
      <img
        src={res.images[0]}
        style={{
          width: "90%",
          height: "90%",
          marginLeft: "5%",
          marginRight: "5%",
          marginTop: "13px",
          // filter: "blur(1px)",
        }}
        alt="menu"
      ></img>
      <div
        style={{
          width: "89%",
          height: "90%",
          backgroundColor: "rgba(0,0,0, 0.4)",
          color: "#ffff",
          position: "relative",
          zIndex: 1,
          bottom: 220,
          left: 10,
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
          alignItems: "center",
        }}
      ></div>
      <div
        style={{
          color: "#ffff",
          position: "relative",
          zIndex: 4,
          bottom: 250,
          left: 10,
          textAlign: "center",
          display: "flex",
          justifyContent: "space-between",
          alignContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            width: 40,
            height: 25,
            backgroundColor: "rgba(255,255,255, 0.7)",
            borderRadius: 10,
            marginLeft: 3,
          }}
        >
          {" "}
          <Typography className={classes.numberText}>
            1/{res.images.length}
          </Typography>
        </div>
        <div
          style={{
            width: 50,
            height: 25,
            Color: "rgba(255,255,255, 0.7)",
            marginRight: 8,
            marginTop: 4,
          }}
        >
          <FavoriteBorderIcon />
        </div>
      </div>

      <div>
        <Button
          variant="contained"
          className={classes.resInfo}
          onClick={() => setIsOpen(true)}
        >
          {res.restaurantId.name}
        </Button>
        {isOpen && (
          <Lightbox
            mainSrc={images[photoIndex]}
            nextSrc={images[(photoIndex + 1) % images.length]}
            prevSrc={
              res.images[(photoIndex + images.length - 1) % images.length]
            }
            onCloseRequest={() => setIsOpen(false)}
            onMovePrevRequest={() =>
              setPhotoIndex((photoIndex + images.length - 1) % images.length)
            }
            onMoveNextRequest={() =>
              setPhotoIndex((photoIndex + 1) % images.length)
            }
            onAfterOpen={() => dispatch(hideHeader())}
          />
        )}
      </div>
    </Paper>
  );
};

export default FavoriteMenuCard;
